import { createEntity } from "../models";
import { generateGroupEntity } from "./utils";

export const addGroupEntity = createEntity.prepend(() => generateGroupEntity());
